import axios from '../base/axios';
import API_KEY from './key';

const GET_ADVENTURE = 'flixfrenzy/redux/GET_ADVENTURE';

// eslint-disable-next-line default-param-last
const adventureReducer = (state = [], action) => {
  switch (action.type) {
    case GET_ADVENTURE:
      return action.payload;
    default:
      return state;
  }
};

export const getAdventure = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=12`).then((res) => {
    dispatch({
      type: GET_ADVENTURE,
      payload: res.data,
    });
  });
};

export default adventureReducer;
